import {type TranslationObject} from '@colonist/i18n'
import {type LobbyImage} from '@colonist/types'
import {ColonistCoinProduct} from './ColonistCoinProduct.ts'
import {ColonistMembershipProduct} from './ColonistMembershipProduct.ts'
import {ColonistOneTimePurchaseProduct} from './ColonistOneTimePurchaseProduct.ts'

export enum PaymentMethod {
    Stripe,
    Xsolla,
    Discord,
    None,
    Apple,
    Android,
}

export enum PaymentProvider {
    Stripe,
    Xsolla,
}

// persisted enum, do not delete or change existing entries
export enum StoreProductType {
    Coin = 0,
    Membership = 1,
    OneTimePurchase = 2,
}

export enum StripeCheckoutTypes {
    Payment = 'payment',
    Subscription = 'subscription',
}

export interface BaseColonistStoreProduct {
    storeProductType: StoreProductType
    type: number
    lobbyImage: LobbyImage
    stripeCheckoutType: StripeCheckoutTypes
    itemQuantity: number
    isActive: () => boolean
    getProductName(): TranslationObject
    getDefaultPrice(): string
}

export function deserializeStoreProduct(storeProductType: StoreProductType, type: number, itemQuantity: number): BaseColonistStoreProduct {
    switch(storeProductType) {
        case StoreProductType.Coin: return ColonistCoinProduct.getPurchaseProduct(type)
        case StoreProductType.Membership: return ColonistMembershipProduct.getMembershipProduct(type)
        case StoreProductType.OneTimePurchase: return ColonistOneTimePurchaseProduct.getOneTimePurchaseProduct(type, itemQuantity)
    }
}
